module.exports = __webpack_public_path__ + "static/img/login_background_mobile.8ec19e39.jpg";